import type { ComponentType } from 'react'

import { AccountingAdditionalCostDeleteDialog } from '@/dialogs/AccountingAdditionalCostDeleteDialog/AccountingAdditionalCostDeleteDialog.tsx'
import { AccountingAdditionalCostTypeCreateDialog } from '@/dialogs/AccountingAdditionalCostTypeCreateDialog/AccountingAdditionalCostTypeCreateDialog.tsx'
import { AccountingAdditionalCostTypesDialog } from '@/dialogs/AccountingAdditionalCostTypesDialog/AccountingAdditionalCostTypesDialog.tsx'
import { AddAccountDialog } from '@/dialogs/AddAccountDialog/AddAccountDialog'
import { AddAdditionalCostDialog } from '@/dialogs/AddAdditionalCostDialog/AddAdditionalCostDialog.tsx'
import { AddCreatorDialog } from '@/dialogs/AddCreatorDialog/AddCreatorDialog.tsx'
import { AddMediaDialog } from '@/dialogs/AddMediaDialog/AddMediaDialog.tsx'
import { AddToTikTokListDialog } from '@/dialogs/AddToTikTokListDialog/AddToTikTokListDialog.tsx'
import { AdditionalCostDetailsDialog } from '@/dialogs/AdditionalCostDetailsDialog/AdditionalCostDetailsDialog.tsx'
import { BirthdayEditDialog } from '@/dialogs/BirthdayEditDialog/BirthdayEditDialog.tsx'
import { BlackFridayPromotionDialog } from '@/dialogs/BlackFridayPromotionDialog/BlackFridayPromotionDialog.tsx'
import { ChatGalleryDialog } from '@/dialogs/ChatGalleryDialog/ChatGalleryDialog.tsx'
import { ChatPriceDialog } from '@/dialogs/ChatPriceDialog/ChatPriceDialog.tsx'
import { Christmas2025PromotionDialog } from '@/dialogs/Christmas2025PromotionDialog/Christmas2025PromotionDialog.tsx'
import { ChristmasPromotionDialog } from '@/dialogs/ChristmasPromotionDialog/ChristmasPromotionDialog.tsx'
import { ColorPickerDialog } from '@/dialogs/ColorPickerDialog/ColorPickerDialog.tsx'
import { ConfirmDeleteMessageEditorDialog } from '@/dialogs/ConfirmDeleteMessageEditorDialog/ConfirmDeleteMessageEditorDialog.tsx'
import { ConfirmationDialog } from '@/dialogs/ConfirmationDialog/ConfirmationDialog.tsx'
import { ContentTypeTikTokFiltersDialog } from '@/dialogs/ContentTypeTikTokFiltersDialog/ContentTypeTikTokFiltersDialog.tsx'
import { CopyScriptDialog } from '@/dialogs/CopyScriptDialog/CopyScriptDialog.tsx'
import { CreateOrEditTikTokListDialog } from '@/dialogs/CreateOrEditTikTokListDialog/CreateOrEditTikTokListDialog.tsx'
import { CreateScriptsFolderDialog } from '@/dialogs/CreateScriptsFolderDialog/CreateScriptsFolderDialog.tsx'
import { CustomListsViewFanDialog } from '@/dialogs/CustomListsViewFanDialog/CustomListsViewFanDialog.tsx'
import { DeleteFanSpendColorDialog } from '@/dialogs/DeleteFanSpendColorDialog/DeleteFanSpendColorDialog.tsx'
import { DeleteMediaDialog } from '@/dialogs/DeleteMediaDialog/DeleteMediaDialog.tsx'
import { DeleteTikTokListDialog } from '@/dialogs/DeleteTikTokListDialog/DeleteTikTokListDialog.tsx'
import { EditScriptsFolderDialog } from '@/dialogs/EditScriptsFolderDialog/EditScriptsFolderDialog.tsx'
import { EditTimezoneDialog } from '@/dialogs/EditTimezoneDialog/EditTimezoneDialog.tsx'
import { FanSpendColorDialog } from '@/dialogs/FanSpendColorDialog/FanSpendColorDialog.tsx'
import { FansListToStartChatWithDialog } from '@/dialogs/FansListToStartChatWithDialog/FansListToStartChatWithDialog.tsx'
import { FunnelTrackingCreateDialog } from '@/dialogs/FunnelTrackingCreateDialog/FunnelTrackingCreateDialog.tsx'
import { FunnelTrackingDeleteDialog } from '@/dialogs/FunnelTrackingDeleteDialog/FunnelTrackingDeleteDialog.tsx'
import { FunnelTrackingEditDialog } from '@/dialogs/FunnelTrackingEditDialog/FunnelTrackingEditDialog.tsx'
import { ImageSelectorDialog } from '@/dialogs/ImageSelectorDialog/ImageSelectorDialog.tsx'
import { LoadGifDialog } from '@/dialogs/LoadGifDialog/LoadGifDialog.tsx'
import { MassMessagesStatisticsDialog } from '@/dialogs/MassMessagesStatisticsDialog/MassMessagesStatisticsDialog.tsx'
import { MediaSettingsDialog } from '@/dialogs/MediaSettingsDialog/MediaSettingsDialog.tsx'
import { MessageMediaSelectionDialog } from '@/dialogs/MessageMediaSelectionDialog/MessageMediaSelectionDialog.tsx'
import { MoreTikTokVideoOrSoundsDialog } from '@/dialogs/MoreTikTokVideoOrSoundsDialog/MoreTikTokVideoOrSoundsDialog.tsx'
import { MoveMediaDialog } from '@/dialogs/MoveMediaDialog/MoveMediaDialog.tsx'
import { NewMessageDialog } from '@/dialogs/NewMessageDialog/NewMessageDialog.tsx'
import { NoSpenderListsViewFanDialog } from '@/dialogs/NoSpenderListsViewFanDialog/NoSpenderListsViewFanDialog'
import { NoSpenderListsFormDialog } from '@/dialogs/NoSpendersListsFormDialog.tsx/NoSpenderListsFormDialog'
import { NoticeDialog } from '@/dialogs/NoticeDialog/NoticeDialog.tsx'
import { PPVTimelineDialog } from '@/dialogs/PPVTimelineDialog/PPVTimelineDialog.tsx'
import { PaymentFailedDialog } from '@/dialogs/PaymentFailedDialog/PaymentFailedDialog.tsx'
import { RemoveScriptsFolderDialog } from '@/dialogs/RemoveScriptsFolderDialog/RemoveScriptsFolderDialog.tsx'
import { RemoveTierDialog } from '@/dialogs/RemoveTierDialog/RemoveTierDialog.tsx'
import { RunOMMWithdrawDialog } from '@/dialogs/RunOMMWithdrawDialog/RunOMMWithdrawDialog.tsx'
import { SaveToListDialog } from '@/dialogs/SaveToListDialog/SaveToListDialog.tsx'
import { SelectMediaFromVaultDialog } from '@/dialogs/SelectMediaFromVaultDialog/SelectMediaFromVaultDialog.tsx'
import { SelectTimePopupDialog } from '@/dialogs/SelectTimePopUpDialog/SelectTimePopupDialog.tsx'
import { SetCreatorSalaryDialog } from '@/dialogs/SetCreatorSalaryDialog/SetCreatorSalaryDialog.tsx'
import { SetMemberSalaryDialog } from '@/dialogs/SetMemberSalaryDialog/SetMemberSalaryDialog.tsx'
import { ShowOtherCreatorsDialog } from '@/dialogs/ShowOtherCreatorsDialog/ShowOtherCreatorsDialog.tsx'
import { SmartGlossaryAIDialog } from '@/dialogs/SmartGlossaryAIDialog/SmartGlossaryAIDialog.tsx'
import { StatisticsSoundsFiltersDialog } from '@/dialogs/StatisticsSoundsFiltersDialog/StatisticsSoundsFiltersDialog.tsx'
import { StatisticsTikTokFiltersDialog } from '@/dialogs/StatisticsTikTokFiltersDialog/StatisticsTikTokFiltersDialog.tsx'
import { TiersDialog } from '@/dialogs/TiersDialog/TiersDialog.tsx'
import { TranslationConfigDialog } from '@/dialogs/TranslationConfigDialog/TranslationConfigDialog.tsx'
import { VaultAddCategoryDialog } from '@/dialogs/VaultAddCategoryDialog/VaultAddCategoryDialog.tsx'
import { VaultDeleteCategoryDialog } from '@/dialogs/VaultDeleteCategoryDialog/VaultDeleteCategoryDialog.tsx'
import { VaultMediaPreviewDialog } from '@/dialogs/VaultMediaPreviewDialog/VaultMediaPreviewDialog.tsx'
import { VaultRenameCategoryDialog } from '@/dialogs/VaultRenameCategoryDialog/VaultRenameCategoryDialog.tsx'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'

import { AddAudioDialog } from './AddAudioDialog/AddAudioDialog'
import { AddProspectDialog } from './AddProspectDialog/AddProspectDialog'
import { BlacklistedWordUsageDetection } from './BlacklistedWordUsageDetectionDialog/BlacklistedWordUsageDetectionDialog'
import { BlockUserDialog } from './BlockUserDialog/BlockUserDialog'
import { CUIIntroDialog } from './CUIIntroDialog/CUIIntroDialog'
import { ChatSummarizeProgressDialog } from './ChatSummarizeProgressDialog/ChatSummarizeProgressDialog'
import { ChatSummaryDialog } from './ChatSummaryDialog/ChatSummaryDialog'
import { ChattingSuggestionsDialog } from './ChattingSuggestionsDialog/ChattingSuggestionsDialog'
import { ClearCollectionConfirmationDialog } from './ClearCollectionConfirmationDialog/ClearCollectionConfirmationDialog'
import { CollectionsDialog } from './CollectionsDialog/CollectionsDialog'
import { CountdownDialog } from './CountdownDialog/CountdownDialog'
import { CreateListDialog } from './CreateListDialog/CreateListDialog'
import { CreateOpenChatsListDialog } from './CreateOpenChatsListDialog/CreateOpenChatsListDialog'
import { CreateSalesTemplateDialog } from './CreateSalesTemplateDialog/CreateSalesTemplateDialog'
import { CustomListsDeleteDialog } from './CustomListsDeleteDialog/CustomListsDeleteDialog'
import { CustomListsFormDialog } from './CustomListsFormDialog/CustomListsFormDialog'
import { DeleteAudioDialog } from './DeleteAudioDialog/DeleteAudioDialog'
import { DeleteCollectionConfirmationDialog } from './DeleteCollectioinConfirmationDialog/DeleteCollectionConfirmationDialog'
import { DeleteFanOriginDialog } from './DeleteFanOriginDialog/DeleteFanOriginDialog'
import { DeleteSalesTemplateDialog } from './DeleteSalesTemplateDialog/DeleteSalesTemplateDialog'
import { DesktopUpdateDialog } from './DesktopUpdateDialog/DesktopUpdateDialog'
import { EditAudioDialog } from './EditAudioDialog/EditAudioDialog'
import { EditFanOriginDialog } from './EditFanOriginDialog/EditFanOriginDialog'
import { EditSalesTemplateDialog } from './EditSalesTemplateDialog/EditSalesTemplateDialog'
import { InviteTaggableCreatorDialog } from './InviteTaggableCreatorDialog/InviteTaggableCreatorDialog'
import { LoggedOutOFDialog } from './LoggedOutOFDialog/LoggedOutOFDialog'
import { MobileTabsDialog } from './MobileTabsDialog/MobileTabsDialog'
import { MuteChatDialog } from './MuteChatDialog/MuteChatDialog'
import { OpenChatsListCreationProgressDialog } from './OpenChatsListCreationProgressDialog/OpenChatsListCreationProgressDialog'
import { PauseOmmDialog } from './PauseOmmDialog/PauseOmmDialog'
import { PinnedMessagesDialog } from './PinnedMessagesDialog/PinnedMessagesDialog'
import { PreviewMediaDialog } from './PreviewMediaDialog/PreviewMediaDialog'
import { PromotionalOfferForFanDialog } from './PromotionalOfferForFanDialog/PromotionalOfferForFanDialog'
import { RecentSpenderDeleteDialog } from './RecentSpenderDeleteDialog/RecentSpenderDeleteDialog'
import { RecentSpenderFormDialog } from './RecentSpenderFormDialog/RecentSpenderFormDialog'
import { RenameCollectionDialog } from './RenameCollectionDialog/RenameCollectionDialog'
import { RenameUserDialog } from './RenameUserDialog/RenameUserDialog'
import { ResumeOmmDialog } from './ResumeOmmDialog/ResumeOmmDialog'
import { StartOmmDialog } from './StartOmmDialog/StartOmmDialog'
import { StopOmmDialog } from './StopOmmDialog/StopOmmDialog'
import { SummarizeChatDialog } from './SummarizeChatDialog/SummarizeChatDialog'
import { TagOtherCreatorsAndReleaseFormsDialog } from './TagOtherCreatorsAndReleaseFormsDialog/TagOtherCreatorsAndReleaseFormsDialog'
import { UnsavedSalesTemplateDialog } from './UnsavedSalesTemplateDialog/UnsavedSalesTemplateDialog'
import { UploadAudioDialog } from './UploadAudioDialog/UploadAudioDialog'
import { WithdrawOmmDialog } from './WithdrawOmmDialog/WithdrawOmmDialog'
import type { DialogProps } from './types'

export const dialogsMap = {
  [DIALOG_TYPE.REMOVE_MESSAGE_CONFIRMATION]: ConfirmDeleteMessageEditorDialog,
  [DIALOG_TYPE.ADD_ACCOUNT]: AddAccountDialog,
  [DIALOG_TYPE.FUNNEL_TRACKING_CREATE]: FunnelTrackingCreateDialog,
  [DIALOG_TYPE.FUNNEL_TRACKING_EDIT]: FunnelTrackingEditDialog,
  [DIALOG_TYPE.FUNNEL_TRACKING_DELETE]: FunnelTrackingDeleteDialog,
  [DIALOG_TYPE.SELECT_TIME_POPUP]: SelectTimePopupDialog,
  [DIALOG_TYPE.MESSAGE_MEDIA_SELECTION]: MessageMediaSelectionDialog,
  [DIALOG_TYPE.RUN_OMM_WITHDRAW_DIALOG]: RunOMMWithdrawDialog,
  [DIALOG_TYPE.BLACKLISTED_WORD_USAGE_DETECTION]: BlacklistedWordUsageDetection,
  [DIALOG_TYPE.ADD_CREATOR]: AddCreatorDialog,
  [DIALOG_TYPE.CONFIRMATION]: ConfirmationDialog,
  [DIALOG_TYPE.PAYMENT_FAILED]: PaymentFailedDialog,
  [DIALOG_TYPE.COLOR_PICKER]: ColorPickerDialog,
  [DIALOG_TYPE.FAN_SPEND_COLOR]: FanSpendColorDialog,
  [DIALOG_TYPE.DELETE_FAN_SPEND_COLOR]: DeleteFanSpendColorDialog,
  [DIALOG_TYPE.IMAGE_SELECTOR]: ImageSelectorDialog,
  [DIALOG_TYPE.TIERS_DIALOG]: TiersDialog,
  [DIALOG_TYPE.REMOVE_TIER_DIALOG]: RemoveTierDialog,

  /** Campaigns */
  [DIALOG_TYPE.BLACK_FRIDAY_PROMOTION]: BlackFridayPromotionDialog,
  [DIALOG_TYPE.CHRISTMAS_PROMOTION]: ChristmasPromotionDialog,
  [DIALOG_TYPE.CHRISTMAS_2025_PROMOTION]: Christmas2025PromotionDialog,

  /** Tiktok Research */
  [DIALOG_TYPE.DELETE_TIKTOK_LIST_DIALOG]: DeleteTikTokListDialog,
  [DIALOG_TYPE.CREATE_OR_EDIT_TIKTOK_LIST_DIALOG]: CreateOrEditTikTokListDialog,
  [DIALOG_TYPE.MORE_TIKTOK_VIDEO_OR_SOUNDS_DIALOG]:
    MoreTikTokVideoOrSoundsDialog,
  [DIALOG_TYPE.CONTENT_TYPE_TIKTOK_FILTERS_DIALOG]:
    ContentTypeTikTokFiltersDialog,
  [DIALOG_TYPE.STATISTICS_TIKTOK_FILTERS_DIALOG]: StatisticsTikTokFiltersDialog,
  [DIALOG_TYPE.STATISTICS_SOUNDS_FILTERS_DIALOG]: StatisticsSoundsFiltersDialog,
  [DIALOG_TYPE.ADD_TO_TIKTOK_LIST_DIALOG]: AddToTikTokListDialog,

  /** Chatting UI */
  [DIALOG_TYPE.EDIT_TIMEZONE]: EditTimezoneDialog,
  [DIALOG_TYPE.LOAD_GIF]: LoadGifDialog,
  [DIALOG_TYPE.MASS_MESSAGE_STATISTICS]: MassMessagesStatisticsDialog,
  [DIALOG_TYPE.EDIT_FAN_ORIGIN]: EditFanOriginDialog,
  [DIALOG_TYPE.DELETE_FAN_ORIGIN]: DeleteFanOriginDialog,
  [DIALOG_TYPE.UNSAVED_SALES_TEMPLATE]: UnsavedSalesTemplateDialog,
  [DIALOG_TYPE.CREATE_SALES_TEMPLATE]: CreateSalesTemplateDialog,
  [DIALOG_TYPE.EDIT_SALES_TEMPLATE]: EditSalesTemplateDialog,
  [DIALOG_TYPE.DELETE_SALES_TEMPLATE]: DeleteSalesTemplateDialog,
  [DIALOG_TYPE.NO_SPENDER_LIST_FORM]: NoSpenderListsFormDialog,
  [DIALOG_TYPE.NO_SPENDER_LIST_VIEW_FANS]: NoSpenderListsViewFanDialog,
  [DIALOG_TYPE.RECENT_SPENDER_LIST_FORM]: RecentSpenderFormDialog,
  [DIALOG_TYPE.DELETE_RECENT_SPENDER_LIST]: RecentSpenderDeleteDialog,
  [DIALOG_TYPE.CUSTOM_LIST_FORM]: CustomListsFormDialog,
  [DIALOG_TYPE.CUSTOM_LIST_DELETE]: CustomListsDeleteDialog,
  [DIALOG_TYPE.CUSTOM_LIST_VIEW_FANS]: CustomListsViewFanDialog,
  [DIALOG_TYPE.SUMMARIZE_CHAT]: SummarizeChatDialog,
  [DIALOG_TYPE.CHAT_SUMMARY]: ChatSummaryDialog,
  [DIALOG_TYPE.CHAT_SUMMARIZE_PROGRESS]: ChatSummarizeProgressDialog,
  [DIALOG_TYPE.MEDIA_PREVIEW]: PreviewMediaDialog,
  [DIALOG_TYPE.ACCOUNTING_ADDITIONAL_COST_TYPE_CREATE]:
    AccountingAdditionalCostTypeCreateDialog,
  [DIALOG_TYPE.ACCOUNTING_ADDITIONAL_COST_TYPE_DELETE]:
    AccountingAdditionalCostDeleteDialog,
  [DIALOG_TYPE.ACCOUNTING_ADDITIONAL_COST_TYPES]:
    AccountingAdditionalCostTypesDialog,
  [DIALOG_TYPE.ADD_ADDITIONAL_COST]: AddAdditionalCostDialog,
  [DIALOG_TYPE.ADDITIONAL_COST_DETAILS]: AdditionalCostDetailsDialog,
  [DIALOG_TYPE.SET_CREATOR_SALARY]: SetCreatorSalaryDialog,
  [DIALOG_TYPE.SET_MEMBER_SALARY]: SetMemberSalaryDialog,
  [DIALOG_TYPE.ADD_PROSPECT]: AddProspectDialog,
  [DIALOG_TYPE.BIRTHDAY_EDIT]: BirthdayEditDialog,
  [DIALOG_TYPE.MUTE_CHAT]: MuteChatDialog,
  [DIALOG_TYPE.CHAT_PRICE]: ChatPriceDialog,
  [DIALOG_TYPE.SELECT_MEDIA_FROM_VAULT]: SelectMediaFromVaultDialog,
  [DIALOG_TYPE.ADD_MEDIA]: AddMediaDialog,
  [DIALOG_TYPE.VAULT_RENAME_CATEGORY]: VaultRenameCategoryDialog,
  [DIALOG_TYPE.VAULT_DELETE_CATEGORY]: VaultDeleteCategoryDialog,
  [DIALOG_TYPE.VAULT_ADD_CATEGORY]: VaultAddCategoryDialog,
  [DIALOG_TYPE.VAULT_MEDIA_PREVIEW]: VaultMediaPreviewDialog,
  [DIALOG_TYPE.MOVE_MEDIA]: MoveMediaDialog,
  [DIALOG_TYPE.DELETE_MEDIA]: DeleteMediaDialog,
  [DIALOG_TYPE.MEDIA_SETTINGS]: MediaSettingsDialog,
  [DIALOG_TYPE.PPV_TIMELINE]: PPVTimelineDialog,
  [DIALOG_TYPE.CREATE_SCRIPTS_FOLDER]: CreateScriptsFolderDialog,
  [DIALOG_TYPE.EDIT_SCRIPTS_FOLDER]: EditScriptsFolderDialog,
  [DIALOG_TYPE.COPY_SCRIPT]: CopyScriptDialog,
  [DIALOG_TYPE.REMOVE_SCRIPTS_FOLDER]: RemoveScriptsFolderDialog,
  [DIALOG_TYPE.NEW_MESSAGE]: NewMessageDialog,
  [DIALOG_TYPE.FANS_LIST_TO_START_CHAT_WITH]: FansListToStartChatWithDialog,
  [DIALOG_TYPE.ADD_AUDIO]: AddAudioDialog,
  [DIALOG_TYPE.EDIT_AUDIO]: EditAudioDialog,
  [DIALOG_TYPE.DELETE_AUDIO]: DeleteAudioDialog,
  [DIALOG_TYPE.UPLOAD_AUDIO]: UploadAudioDialog,
  [DIALOG_TYPE.COUNTDOWN]: CountdownDialog,
  [DIALOG_TYPE.LOGGED_OUT_OF]: LoggedOutOFDialog,
  [DIALOG_TYPE.CUI_INTRO]: CUIIntroDialog,
  [DIALOG_TYPE.BLOCK_USER]: BlockUserDialog,
  [DIALOG_TYPE.RENAME_USER]: RenameUserDialog,
  [DIALOG_TYPE.PINNED_MESSAGES]: PinnedMessagesDialog,
  [DIALOG_TYPE.MOBILE_TABS]: MobileTabsDialog,
  [DIALOG_TYPE.COLLECTIONS]: CollectionsDialog,
  [DIALOG_TYPE.RENAME_COLLECTION]: RenameCollectionDialog,
  [DIALOG_TYPE.CLEAR_COLLECTION_CONFIRMATION]:
    ClearCollectionConfirmationDialog,
  [DIALOG_TYPE.DELETE_COLLECTION_CONFIRMATION]:
    DeleteCollectionConfirmationDialog,
  [DIALOG_TYPE.CREATE_LIST]: CreateListDialog,
  [DIALOG_TYPE.CREATE_OPEN_CHATS_LIST]: CreateOpenChatsListDialog,
  [DIALOG_TYPE.OPEN_CHATS_LIST_CREATION_PROGRESS]:
    OpenChatsListCreationProgressDialog,
  [DIALOG_TYPE.PROMOTIONAL_OFFER_FOR_FAN]: PromotionalOfferForFanDialog,
  [DIALOG_TYPE.TAG_OTHER_CREATORS_AND_RELEASE_FORMS]:
    TagOtherCreatorsAndReleaseFormsDialog,
  [DIALOG_TYPE.INVITE_TAGGABLE_CREATOR]: InviteTaggableCreatorDialog,
  [DIALOG_TYPE.SHOW_OTHER_CREATORS]: ShowOtherCreatorsDialog,
  [DIALOG_TYPE.SMART_GLOSSARY_AI_DIALOG]: SmartGlossaryAIDialog,
  [DIALOG_TYPE.START_OMM_DIALOG]: StartOmmDialog,
  [DIALOG_TYPE.STOP_OMM_DIALOG]: StopOmmDialog,
  [DIALOG_TYPE.RESUME_OMM_DIALOG]: ResumeOmmDialog,
  [DIALOG_TYPE.WITHDRAW_OMM_DIALOG]: WithdrawOmmDialog,
  [DIALOG_TYPE.PAUSE_OMM_DIALOG]: PauseOmmDialog,
  [DIALOG_TYPE.CHAT_GALLERY]: ChatGalleryDialog,
  [DIALOG_TYPE.SAVE_TO_LIST]: SaveToListDialog,
  [DIALOG_TYPE.NOTICE]: NoticeDialog,
  [DIALOG_TYPE.CHAT_SUGGESTIONS]: ChattingSuggestionsDialog,
  [DIALOG_TYPE.DESKTOP_UPDATE_DIALOG]: DesktopUpdateDialog, // TODO: Remove this once we no longer receive error log from users
  [DIALOG_TYPE.TRANSLATION_CONFIG_DIALOG]: TranslationConfigDialog,
} as const

export type DialogEventPayload<T = typeof dialogsMap> = {
  [Type in keyof T]: T[Type] extends ComponentType<infer P>
    ? { type: Type; isPersistent?: boolean } & Omit<P, keyof DialogProps>
    : never
}[keyof T]
